module.exports = __webpack_public_path__ + "media/images/icons/deezer-podcasts-lg-ecbe37aebc0345be2ec79478acda0d50.svg";